

export type CommitFn = () => Promise<void> | void

export default function isBlankNumeric(val: unknown): boolean {
  if (val === null || val === undefined) return true
  if (typeof val === 'string' && val.trim() === '') return true
  if (typeof val !== 'number' && typeof val !== 'string') return true

  const s = String(val).trim()

  const pattern = /^-?\d+(\.\d+)?$/
  if (!pattern.test(s)) return true

  const num = Number(s)
  return !Number.isFinite(num)
}

export const statusMap: Record<string, string> = {
  "0": 'Uncounted',
  "1": 'Counted',
  "2": 'Keyed',
  "4": 'Variance',
  "5": 'Confirmed Variance'

}




